import React, { Component } from 'react';

export class TouchableOpacityLinkExternal extends Component {
    render() {
    	const { newTab } = this.props;
        return (
        	<>
        		{newTab ?
        			<a target="_blank" {...this.props}></a>
        			:
        			<a {...this.props}></a>
        		}
    		</>
        );
    }
}

export default TouchableOpacityLinkExternal;